<div class="card mb-5 zone-scatter-card">
  <div class="card-header" style="border-bottom: none;" *ngIf="data?.title || subtitle || showLegend || hasHeaderActions">
    <div class="card-title d-flex flex-column">
      <h4 *ngIf="data?.title">{{ data.title | capitalCase }}</h4>
      <span class="zone-scatter-subtitle" *ngIf="subtitle">{{ subtitle }}</span>
    </div>
    <div class="zone-scatter-header-side">
      <div class="zone-scatter-bubble-scale-legend" *ngIf="showBubbleScaleLegend; else defaultLegend" [ngStyle]="bubbleLegendScaleStyle">
        <div class="zone-scatter-bubble-scale-description">{{ bubbleLegendDescription }}</div>
        <div class="zone-scatter-bubble-scale-row">
          <span
            class="zone-scatter-bubble-scale-dot"
            *ngFor="let size of bubbleLegendScaleBubbleSizes; trackBy: trackByBubbleLegendSize"
            [style.width.px]="size"
            [style.height.px]="size">
          </span>
          <span class="zone-scatter-bubble-scale-text">{{ bubbleLegendScaleText }}</span>
        </div>
      </div>
      <ng-template #defaultLegend>
        <div class="zone-scatter-legend" *ngIf="showLegend">
        <span class="legend-dot" [ngStyle]="legendDotStyle"></span>
        <span>{{ legendLabel }}</span>
      </div>
      </ng-template>
      <button
        *ngFor="let action of headerActions; trackBy: trackByHeaderAction"
        type="button"
        class="zone-scatter-header-action"
        [ngClass]="action.className || action.buttonClass || action.variant"
        [ngStyle]="action.style"
        [disabled]="action.disabled === true"
        (click)="onHeaderActionClick(action, $event)">
        {{ action.label || action.title || action.key }}
      </button>
    </div>
  </div>
  <div class="card-body">
    <div
      class="zone-scatter-bubble-scale-legend zone-scatter-bubble-scale-overlay"
      *ngIf="showBubbleScaleOverlay"
      [ngStyle]="bubbleLegendScaleStyle">
      <div class="zone-scatter-bubble-scale-description">{{ bubbleLegendDescription }}</div>
      <div class="zone-scatter-bubble-scale-row">
        <span
          class="zone-scatter-bubble-scale-dot"
          *ngFor="let size of bubbleLegendScaleBubbleSizes; trackBy: trackByBubbleLegendSize"
          [style.width.px]="size"
          [style.height.px]="size">
        </span>
        <span class="zone-scatter-bubble-scale-text">{{ bubbleLegendScaleText }}</span>
      </div>
    </div>
    <div
      id="{{ data.widgetId }}"
      class="zone-scatter-chart"
      [style.height]="data?.height || 'var(--dvm-chart-height, 420px)'"
      style="width: 100%">
    </div>
  </div>
</div>
